import apiWrapper from '@/helpers/apiWrapper';
import type { ISport } from '@/types/sport';

export default {
  get: () => apiWrapper.get<{
    sports: ISport[],
  }>('/api/v1/sports'),
};
